// extracted by mini-css-extract-plugin
export default {"coverHolder":"NewsDetails_coverHolder__gEDvY","newsDetailsTitle":"NewsDetails_newsDetailsTitle__bPFq7","newsDetailsDesc":"NewsDetails_newsDetailsDesc__nPKeF"};